var render = function render(_c,_vm){return (_vm.props.data)?_c('span',[_c('IconFont',{style:({ 'font-size': '22px' }),attrs:{"type":_vm.props.data.value}}),_c('span',{staticClass:"nav-menu-text"},[_vm._v(" "+_vm._s(_vm.props.text)+" ")])],1):_c('span',{staticClass:"nav-menu-text",staticStyle:{"padding-left":"31px"}},[_vm._v(" "+_vm._s(_vm.props.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }